import { frontendURL } from 'dashboard/helper/URLHelper';

const PeopleManagementIndex = () =>
  import('./pages/PeopleManagementIndex.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/people-management'),
      name: 'people_management_index',
      component: PeopleManagementIndex,
      meta: {
        permissions: ['administrator'],
      },
    },
  ],
};
